import { useNavigate } from "react-router-dom";

import { useSessionStore } from "@/entities/session";
import { Button } from "@/shared/ui/button";
import { useQueryClient } from "@tanstack/react-query";

export const LogoutButton = () => {
  const { logout } = useSessionStore();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleClick = () => {
    queryClient.clear();
    logout();
    navigate("/");
  };

  return (
    <Button
      className="w-full font-medium"
      variant={"destructive"}
      onClick={handleClick}
    >
      Выйти
    </Button>
  );
};
